import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { Modal, Button } from "@renderbus/ui";
import styled from "styled-components";
import { TicketBox } from "./component/ticket-box";
import { CrashForm } from "./component/crash-form";
import useForm from "antd/es/form/hooks/useForm";
import {
  useLotteryStore,
  LotteryStoreContainerProvider,
} from "./store/lottery-store";
import { LotteryModalStyle } from "./atom.js";
import { LeftOutlined } from "@ant-design/icons";
import CashSuccessIcon from "@/assets/icons/topup/cash-success";
import { ModalPage } from "./constants/cash-status";
interface LotteryModalProps {
  openLotteryModal: boolean;
  onClose: () => void;
}

export function LotteryModalView({
  openLotteryModal = false,
  onClose,
}: LotteryModalProps) {
  const { t } = useTranslation("topup");
  const [open, setOpen] = useState(false);
  const { currentModalPage, currentActivityID, setCurrentModalPage } =
    useLotteryStore();

  const [form] = useForm<{
    name: string;
    phone: string;
    address: string;
  }>();

  useEffect(() => {
    setOpen(openLotteryModal);
  }, [openLotteryModal]);

  useEffect(() => {
    if (!open) setCurrentModalPage(ModalPage.PrizeCouponPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <>
      <Modal
        width={860}
        open={open}
        footer={null}
        size={"large"}
        title={
          <div
            className={
              currentModalPage === ModalPage.CashInformationPage
                ? "topup_form_back"
                : "topup_prize_back"
            }
          >
            {currentModalPage === ModalPage.CashInformationPage && (
              <div
                onClick={() => setCurrentModalPage(ModalPage.PrizeCouponPage)}
                style={{ cursor: "pointer" }}
              >
                <LeftOutlined />
                {t("topup_modal_form_back")}
              </div>
            )}
            {t(
              currentModalPage === ModalPage.PrizeCouponPage
                ? "topup_lottery_drawer_title"
                : "topup_modal_form_title"
            )}
          </div>
        }
        className="renderbus-ui--modal lottery-modal"
        children={
          <>
            {" "}
            {currentModalPage === ModalPage.PrizeCouponPage && (
              <TicketBox
                onCloseModal={() => {
                  setOpen(false);
                  onClose();
                }}
              />
            )}
            {currentModalPage === ModalPage.CashInformationPage && (
              <CrashForm
                form={form}
                currentActivityID={currentActivityID}
                onCloseModal={() => {
                  setCurrentModalPage(ModalPage.CashInformationSuccess);
                }}
              />
            )}
            {currentModalPage === ModalPage.CashInformationSuccess && (
              <CashSuccessContainer>
                <CashSuccessIcon />
                <div className="submit-text">
                  {t("topup_lottery_cash_submit_text")}
                </div>
                <div className="success-text">
                  {t("topup_lottery_cash_success_text")}
                </div>
                <Button
                  type="primary"
                  onClick={() => {
                    setOpen(false);
                    onClose();
                  }}
                >
                  {t("topup_lottery_cash_submit_confirm")}
                </Button>
              </CashSuccessContainer>
            )}
          </>
        }
        onCancel={() => {
          setOpen(false);
          onClose();
        }}
      />
      <LotteryModalStyle />
    </>
  );
}

export function LotteryModal(props: LotteryModalProps) {
  return (
    <LotteryStoreContainerProvider>
      <LotteryModalView {...props} />
    </LotteryStoreContainerProvider>
  );
}

const CashSuccessContainer = styled.div`
  margin: 82px auto 16px;
  line-height: 22px;
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 450px;
  .submit-text {
    color: #e1e4e7;
    font-weight: 600;
    font-size: 18px;
    padding: 24px 0 26px;
  }
  .success-text {
    color: #b9c3c6;
    font-size: 16px;
    margin-bottom: 190px;
  }
  button {
    width: 136px;
    padding: 10px;
    height: 40px;
    line-height: 1;
  }
`;
